import { formatDateTimeRange, formatPriceRange } from '../../../utils/functions';
import { ReactComponent as Arrow } from '../../../assets/arrow.svg';
import { ReactComponent as HelloAssoLogo } from './helloasso-logo.svg';
import defaultImage from './default_image.png';
import style from './style.module.scss';

export const SingleEvent = ({ event }) => {
    return (
        <a className={style.block} href={event.ha_link} target="_blank" rel="noreferrer">
            <div className={style.imageWrapper}>
                <img
                    className={style.image}
                    src={event.image && event.image !== '' ? event.image : defaultImage}
                    alt={event.post_title}
                />
            </div>

            <div className={style.info}>
                <h3>{event.post_title}</h3>
                {event.description && <span>{event.description}</span>}

                <div className={style.infoList}>
                    {event.event_type && <span>🎒 {event.event_type}</span>}
                    {event.start_date && event.end_date && (
                        <span>
                            🗓️ {formatDateTimeRange(event.start_date, event.end_date)}
                        </span>
                    )}
                    {event.address && event.zip_code && event.city && (
                        <span>
                            📍 {event.place} {event.address} {event.zip_code} {event.city}
                        </span>
                    )}
                    {event.min_price && event.max_price && (
                        <span>
                            🎟️ {formatPriceRange(event.min_price, event.max_price)}
                        </span>
                    )}

                    <div className={style.infoFooter}>
                        <HelloAssoLogo />
                        <span className={style.link} target="_blank" rel="noreferrer">
                            Je participe
                            <Arrow />
                        </span>
                    </div>
                </div>
            </div>
        </a>
    );
};
